export default "__VITE_ASSET__4bcce5cc__"